import pageServices from '@/services/page';
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';
import { replaceParamsByModel } from '@/helpers/replaceParamsByModel';
import { downloadFile } from '@/helpers/utils';
import { returnNodeDataRequest, executeServicesData } from '@/helpers/page';
import { checkElectronicSignatureByUserPassword } from '@/services/authentication';
import { compileDynamicString } from '@/helpers/page';
import axios from 'axios';
import _ from 'lodash';

import {
  getListIndex,
  initLookups,
  initLookupsList,
  setLookupListScheme,
  conditionEngine,
  lookupEngine,
  showMessage,
  checkParams,
  loadPage,
  loadMode,
  showExecuteParams,
  downloadECM,
  uploadEcm,
  generatePdfReport,
  generateExcelReport,
  generateTxtReport,
  redirect,
  afterEvents,
  getModels,
  getExecuteMode,
  getMessageClass,
  getData,
  sleep,
  executeLoopActionInMultipages,
  beforeActionAdapter,
  mainActionAdapter
} from '@/helpers/page';

export default {
  setMain: ({ commit }, page) => commit('setMain', page),

  executePageEvents: ({ state, commit, dispatch }) =>
    pageEvents(state, commit, dispatch, { page: 'dev', mode: 'list' }),

  updateSelectedItems: ({ commit }, params) => commit('updateSelectedItems', params),

  clear: ({ commit, rootState }) => commit('clear', rootState.layout.footer.page),

  setTabScheme: ({ commit }, { page, mode, tab }) => commit('setTabScheme', { page, mode, tab }),

  setStepScheme: ({ commit }, { page, mode, tab }) => commit('setStepScheme', { page, mode, tab }),

  lookup: ({ dispatch }, params) =>
    params.info.mode === 'list' ? dispatch('lookupList', params) : dispatch('lookupForm', params),

  setLookupListScheme: async ({ commit, state }, params) => {
    setLookupListScheme(commit, state, params.page);
    await initLookupsList(commit, state, params);
  },

  initConditionsList: ({ commit }, params) => commit('initConditionsList', params),

  initConditionsOnSelectedItems: ({ commit }, params) => commit('initConditionsOnSelectedItems', params),

  initInlineConditionsList: ({ commit }, params) => commit('initInlineConditionsList', params),

  setActionsCondition: ({ commit }, page) => commit('setActionsCondition', page),

  hideGroup: ({ commit }, params) => commit('hideGroup', params),

  showGroups: ({ commit }, params) => commit('showGroups', params),

  setCurrentTab: ({ commit }, params) => commit('setCurrentTab', params),

  load: async ({ commit, state, dispatch, rootState }, params) => {
    params = checkParams(params, commit);

    if (params.notification === true) {
      commit('clear');
      await eventBus.$emit(HANDLERS.ENABLE_FOOTER);
    }

    if (state.schemes[params.page]) {
      await loadMode(state, commit, dispatch, params, rootState)
    } else {
      await loadPage(state, commit, dispatch, params, rootState)
    }
  },

  loadTab: async ({ commit, dispatch, state }, { mode, page, tab }) => {
    page === 'dev' && (await sleep(50));

    const { typeRequest, bodyRequest } = returnNodeDataRequest(
      { schema: state.schemes[page][mode].tabs.content[tab] },
      { defaultFilter: state.defaultFilter[page], page, isRedirect: true }
    );

    const { data } = await executeServicesData(typeRequest, bodyRequest);

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return;
    }

    commit('setModel', { page, data: data.values[0], mode });
    await dispatch('maskCondition', { page, mode, tab, hasMaskedField: data.readOnly });
  },

  loadDataValues: async ({ commit, state, getters }, { mode, page, filter, reOrder }) => {
    mode = mode || 'list';

    // Função utilitária para extrair apenas campos de paginação e ordenação
    const extractPaginationSortFields = (obj) => {
      if (!obj || typeof obj !== 'object') return {};
      const keys = ['limit', 'offset', 'sortBy', 'sortDesc', 'total_rows'];
      return Object.fromEntries(
        keys.filter(key => obj[key] !== undefined).map(key => [key, obj[key]])
      );
    }

    const namePagePaginate = page + '_paginate';
    // Atribui o resultado de getters.pageFilter(namePagePaginate) a pageFilter,
    // e desestrutura com valores padrão para evitar erros se as propriedades forem indefinidas.
    const pageFilter = getters.pageFilter(namePagePaginate) ?? {};
    const { form = {}, filter: filterPaginate = {}, defaultFilter = {} } = pageFilter;

    const pageTarget = state.schemes[page][mode];
    const parent = state.parents[page];
    const objFilterParent = {};
    const filterPage = {
      ...filterPaginate,
      ...filter,
      ...(state.pageFilter[page] || {})
    };

    const { typeRequest, bodyRequest } = returnNodeDataRequest(
      { schema: pageTarget },
      {
        form,
        filter: filterPage,
        defaultFilter: { ...(state.defaultFilter[page] || {}), ...defaultFilter },
        page,
        isRedirect: false
      }
    );

    // Recupera defaultFilter baseadas nas telas pai
    const {
      form: model,
      filter: filterParent,
      defaultFilter: defaultFilterParent
    } = getData(state, { page, mode, filter, parent });
    objFilterParent.model = model ?? {};
    objFilterParent.filter = filterParent;
    objFilterParent.defaultFilter = defaultFilterParent;

    if (reOrder) {
      bodyRequest.filter = extractPaginationSortFields(bodyRequest.filter);
      bodyRequest.defaultFilter = extractPaginationSortFields(bodyRequest.defaultFilter);
      objFilterParent.filter = extractPaginationSortFields(objFilterParent.filter);
      objFilterParent.defaultFilter = extractPaginationSortFields(objFilterParent.defaultFilter);
    }

    _.merge(bodyRequest, objFilterParent);

    showExecuteParams('loadDataValues', page, mode, bodyRequest.filter, bodyRequest.defaultFilter, bodyRequest.model);
    const { data } = await executeServicesData(typeRequest, bodyRequest);

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return;
    }

    if (bodyRequest?.filter) {
      commit('clearPageFilter', namePagePaginate);
      commit('setPageFilter', { page, redirectParams: bodyRequest.filter });
    }
    commit('setModel', { page, data: data.values, mode });
  },

  loadLookups: async ({ commit, state }, params) => {
    if (params.page === 'dev') return; // Mokcar dados para initlookup(b_portal_dev)

    return initLookups(commit, state, params);
  },

  conditions: ({ commit }, params) => {
    if (params.mode === 'list') {
      commit('setInlineConditionsList', params);
    } else if (params.mode === 'subPages') {
      return;
    } else {
      commit('setConditions', params);
    }
  },

  getEntry: async ({ commit, state, dispatch, getters }, { page, entry, mode, changeMode, navigation, resetTab }) => {
    if (page === 'dev') {
      showMessage(commit, {
        message: 'Você está em modo DEV, não é permitido executar ação de redirect!',
        color: 'warning'
      });
      return;
    }

    if (!entry) {
      if (navigation) {
        const index = await getListIndex(page, state.models[page]['list'], navigation, state);
        const item = state.models[page]['list'][index];
        if (item && index !== -1) entry = item;
        else return;
      }
    }

    // validar se é table ou data iterator
    const { attributesDataIterator, attributesTable } = state.schemes[page]['list'].attributes;
    let keyValue;

    attributesTable ? (keyValue = attributesTable.keyValue) : (keyValue = attributesDataIterator.keyValue);

    const lineIndex = state.models[page]['list'].find(x => x[keyValue] == entry[keyValue]);

    const masterContent = 'master' in state.schemes[page][mode];
    const stepContent = 'steps' in state.schemes[page][mode];

    if (stepContent) {
      commit('setDefaultFilter', { page, model: entry });
      commit('changePageMode', { page, mode });
      return;
    }

    let pageTarget = state.schemes[page][mode];
    const filter = getters.pageFilter(page) || {};

    const { typeRequest, bodyRequest } = returnNodeDataRequest(
      { schema: pageTarget },
      {
        form: lineIndex,
        filter: { ...(state.pageFilter[page] || {}), ...filter },
        defaultFilter: state.defaultFilter[page],
        page,
        isRedirect: true
      }
    );

    const { data } = await executeServicesData(typeRequest, bodyRequest);

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return;
    }

    commit('setModel', { page, data: data.values[0], mode, masterContent, changeMode });

    if (masterContent) {
      commit('setDefaultFilter', { page, model: data.values[0] });
    }

    if (changeMode) {
      commit('changePageMode', { page, mode });
    }
    if (masterContent && 'fields' in state.schemes[page][mode].master) {
      await initLookups(commit, state, { page, mode: 'master' });
      dispatch('conditions', { page, mode: 'master' });
    } else {
      await initLookups(commit, state, { page, mode });
      if (masterContent) dispatch('conditions', { page, mode: 'master' });
      dispatch('conditions', { page, mode });
    }
    dispatch('maskCondition', { page, mode, hasMaskedField: data.readOnly });

    /* Removendo devido a um bug de performance, forçando a repetição de dispatchs e services sem necessidade
    if (navigation || resetTab) {
      await sleep(200);
      eventBus.$emit(HANDLERS.RESET_TAB, page);
    }*/
  },

  maskCondition: ({ commit }, params) => commit('maskCondition', params),

  loadStep: async ({ commit, dispatch, state }, { page, mode, step }) => {
    // Verifiquei se pageFilter está definida, caso contrário, atribuí um objeto vazio como valor padrão
    const pageFilter = state.pageFilter || {};

    // Agora posso acessar pageFilter[page] sem que o código lance um erro
    const filter = pageFilter[page] || {};
    const defaultFilterInState = Object.values(state.defaultFilter);
    const defaultFilter = defaultFilterInState.length ? defaultFilterInState[defaultFilterInState.length - 1] : {};

    const { typeRequest, bodyRequest } = returnNodeDataRequest(
      { schema: state.schemes[page][mode].steps.content[step] },
      { form: {}, filter, defaultFilter, page, isRedirect: true }
    );

    const { data } = await executeServicesData(typeRequest, bodyRequest);

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return;
    }

    commit('setModel', { page, data: data.values[0], mode });

    commit('setStepScheme', { page, mode, step });
    dispatch('maskCondition', { page, mode, step, hasMaskedField: data.readOnly });
  },

  lookupForm: async ({ state, commit }, params) => {
    let { page, mode, tab, step } = params.info;
    let allFields = [];

    if (tab) {
      allFields = state.schemes[page][mode].tabs.content[tab].fields;
      state.schemes[page][mode].tabs.content[tab].groups.filter(group =>
        group.fields.map(field => (allFields = [...allFields, field]))
      );
    } else if (step) {
      allFields = state.schemes[page][mode].steps.content[step].fields;
      state.schemes[page][mode].steps.content[step].groups.filter(group =>
        group.fields.map(field => (allFields = [...allFields, field]))
      );
    } else {
      allFields = state.schemes[page][mode].fields;
      state.schemes[page][mode].groups.filter(group => group.fields.map(field => (allFields = [...allFields, field])));
    }

    for (let item of params.fill) {
      let field = allFields.find(p => p.model === item);
      let model = {
        name: item,
        model: params.model,
        fill: params.fill,
        filledBy: params.filledBy,
        InvokeName: field ? field.fieldName : null,
        procedure: field && 'procedure' in field ? field.procedure.name : null,
        component: field && 'component' in field ? field.component : null,
        requestApi: field && 'requestApi' in field ? field.requestApi : null,
        page,
        typeLookup: field && 'typeLookup' in field ? field.typeLookup : null,
        lookupTextKey: field && 'lookupTextKey' in field ? field.lookupTextKey : null,
        lookupValueKey: field && 'lookupValueKey' in field ? field.lookupValueKey : null
      };

      const { data } = await pageServices.lookups(model);

      params.model = data.model;

      if (field) {
        if (field.typeLookup && field.typeLookup !== 'conditional')
          commit('setLookup', { data: data, info: params.info });
      }

      commit('updateModel', { page, mode, model: data.model });

      field && field.hasConditions && commit('setConditions', params.info);
    }
  },

  lookupList: async ({ state, commit }, params) => {
    let { page, mode } = params.info;
    let param = state.schemes[page][mode].attributes.attributesTable.keyValue;
    let key = params.model[param];
    let allFields = state.schemes[page][mode].lookups[key];

    for (let item of params.fill) {
      let field = allFields.find(p => p.model === item);
      let model = {
        name: item,
        model: params.model,
        fill: params.fill,
        filledBy: params.filledBy,
        InvokeName: field ? field.fieldName : null,
        procedure: field && 'procedure' in field ? field.procedure.name : null,
        component: field && 'component' in field ? field.component : null,
        requestApi: field && 'requestApi' in field ? field.requestApi : null,
        page,
        typeLookup: field && 'typeLookup' in field ? field.typeLookup : null,
        lookupTextKey: field && 'lookupTextKey' in field ? field.lookupTextKey : null,
        lookupValueKey: field && 'lookupValueKey' in field ? field.lookupValueKey : null
      };

      const { data } = await pageServices.lookups(model);

      commit('setLookupList', { data, info: params.info });
      commit('updateModelList', { page, mode, model: data.model });

      field && field.hasConditions && commit('setInlineConditionsList', params.info);
    }
  },

  checkEletronicSignature: async (
    { commit, dispatch, state },
    { page, mode, origin, action, master, child, name, model }
  ) => {
    const { typeRequest, bodyRequest } = returnNodeDataRequest(
      { schema: action.before },
      { form: model, filter: {}, defaultFilter: {}, page, isRedirect: false, InvokeName: 'Assinatura Eletrônica' }
    );
    const initialModel = { [action.before[typeRequest]?.model ?? 'password']: null };

    const { data } = await executeServicesData(typeRequest, { ...bodyRequest, initialModel });

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return;
    }

    if (data.dictionaryReturns['@id_retorno'] < 0) {
      showMessage(commit, {
        message: data.dictionaryReturns['@ds_retorno'],
        color: data.dictionaryReturns['@message_class'] || 'error'
      });

      return;
    } else if (data.dictionaryReturns['@id_retorno'] > 0) {
      showMessage(commit, {
        message: data.dictionaryReturns['@ds_retorno'],
        color: data.dictionaryReturns['@message_class'] || 'warning'
      });

      return;
    } else {
      eventBus.$emit(HANDLERS.CLOSE_DIALOG_ELECTRONIC_SIGNATURE);
      dispatch('executeAction', { page, mode, origin, action, master, child });
    }
  },

  checkElectronicSignatureByUserPassword: async (
    { commit, dispatch },
    { page, mode, origin, action, master, child, model }
  ) => {
    var { data } = await checkElectronicSignatureByUserPassword(model);

    if (data.validPassword !== true) {
      showMessage(commit, { message: 'Falha na autenticação da senha.', color: 'error' });
      return;
    }

    eventBus.$emit(HANDLERS.CLOSE_DIALOG_ELECTRONIC_SIGNATURE);
    dispatch('executeAction', { page, mode, origin, action, master, child });
  },

  actionBefore: async ({ state, commit, dispatch }, { page, mode, origin, action, master, child, model }) => {
    console.info(`Executando a ação BEFORE [${action.actionName}] da page: ${page}`);
    let modelForm;

    if (model === undefined) {
      const { model: recoveredModel } = getModels(state, { page, mode, origin, action, master, child });
      modelForm = recoveredModel;
    } else {
      modelForm = model;
    }

    const { typeRequest, bodyRequest } = returnNodeDataRequest(
      { schema: action.before },
      {
        form: modelForm,
        filter: {},
        defaultFilter: {},
        page,
        isRedirect: false,
        InvokeName: `Ação Before de ${action.actionName}`
      }
    );

    const { data } = await executeServicesData(typeRequest, bodyRequest, mode === 'list');

    if (data === null) {
      showMessage(commit, {
        message:
          'Não foi definido uma Procedure/ Componente ou RequestAPI para o before desta ação. Ou os dados retornados são nulos.',
        color: 'error'
      });
      return false;
    }

    const messageClass = getMessageClass(data);

    // Verifica se data.value contém dados
    let valuesIsValid = mode !== 'list' ? data.values.length > 0 : Object.keys(data.values).length > 0;

    if (valuesIsValid || messageClass === 'success') {
      await commit('setModel', { page, data: mode !== 'list' ? data.values[0] : data.values, mode });
    }

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return false;
    }

    if (messageClass !== 'success') {
      showMessage(commit, {
        message: data.dictionaryReturns['@ds_retorno'],
        color: data.dictionaryReturns['@message_class'] || messageClass,
        sweetAlert: true
      });

      return false;
    }

    if (!action.executePageActions && !action.pageAction) {
      dispatch('executeAction', { page, mode, origin, action, master, child });
    }
    return true;
  },

  pageEvents: async ({ state, commit, dispatch }, params) => {
    const { page, mode, setAutomatically } = params;
    const bgPage = state.schemes[page].background;

    if (!(page.toLowerCase().indexOf('footer') > -1)) {
      eventBus.$emit(HANDLERS.SHOW_BACKGROUND, bgPage);
    }

    await lookupEngine(commit, state, { page, mode });

    conditionEngine(state, dispatch, { page, mode });

    if (setAutomatically) {
      if (
        mode === 'list' && state.models[page][mode].length === 1 && state.schemes[page][mode].display === 'list'
          ? state.schemes[page][mode].targetList === 'page'
          : state.schemes[page][mode].targetCard === 'page'
      ) {
        let newMode =
          state.schemes[page][mode].display === 'list'
            ? state.schemes[page][mode].attributes.attributesTable.editMode
            : state.schemes[page][mode].attributes.attributesDataIterator.editMode;
        await sleep(30);
        await dispatch('getEntry', { page, mode: newMode, entry: state.models[page][mode][0], changeMode: true });
      }
    }

    if (state.schemes[page][mode]?.actions?.items) {
      for (let action of state.schemes[page][mode].actions.items) {
        if (action.executeAfterPageLoad) {
          await dispatch('executeAction', { page, mode, origin, action });
        }
      }
    }
  },

  executeAction: async ({ commit, state, dispatch, getters, rootGetters, rootState }, params) => {
    if (params.page === 'dev' && 'redirect' in params.action) {
      showMessage(commit, { message: 'Redirect não permitido! (DEV MODE ON)', color: 'warning' });
      return;
    }
    if (params.action['executePageActions']) {
      // Inicializa rotina de loop para o multipage

      // continueExecution guarda o resultado das validações
      // Caso o loop retorno FALSE, a rotina é interrompida
      let continueExecution;

      // Executa e valida se a response [id_retorno] de todos os BEFORES da page retornou sucesso
      continueExecution = await executeLoopActionInMultipages(
        { getters, dispatch },
        params,
        beforeActionAdapter,
        'actionBefore'
      );
      if (continueExecution === false) return;

      // Executa e valida se a response [id_retorno] de todos as ACTIONS da page retornou sucesso
      continueExecution = await executeLoopActionInMultipages(
        { getters, dispatch },
        params,
        mainActionAdapter,
        'executeAction'
      );
      if (continueExecution === false) return;
    }

    console.info(`Executando a ação PRINCIPAL [${params.action.actionName}] da page: ${params.page}`);
    const { model, initialModel, twoModels, originalMode, defaultFilter, filterTable } = getModels(state, params);
    let actionType, requestParams, uploadResult, mockData;

    try {
      if ('externalUrl' in params.action) {
        let path = '';

        params.action.externalUrl.url = compileDynamicString({
          page: params.page,
          mode: params.mode,
          originalString: params.action.externalUrl.url,
          index: params.index
        });

        if ('token' in params.action.externalUrl) {
          const { client_id, scope } = params.action.externalUrl.token;
          path = `#/RedirectExternalAuthenticated?url=${params.action.externalUrl.url}&c=${client_id}&s=${scope}`;
          if ('queryParam' in params.action.externalUrl.token) {
            path += `&qp=${params.action.externalUrl.token.queryParam}`;
          }
        }

          if (path === '') path = replaceParamsByModel(params.action.externalUrl.url, model);
        // Só chama window.open se path for string não vazia
        if (typeof path === 'string' && path.trim()) {
          window.open(path, '_blank', 'noopener,noreferrer');
        }
        // showMessage(commit, { message: 'Não é possível enviar a model para um link externo modo lista', color: 'warning' });
      }

      if ('txt' in params.action) {
        generateTxtReport(params.action, model);
        return;
      }

      if ('report' in params.action) {
        generatePdfReport(params.action, model, commit);
        return;
      }

      if ('excel' in params.action) {
        generateExcelReport(params.action, model, commit, params.page);
        return;
      }

      if ('ecm' in params.action) {
        if (params.action.ecm.download) {
          downloadECM(params.action, model);
          return;
        }
        uploadResult = await uploadEcm(state, params, rootState, originalMode, commit);
      }

      if ('redirect' in params.action) {
        if (state.schemes[params.page]?.list?.cleanFiltersAfterReturn) {
          commit('cleanFiltersAfterReturn', params.page);
        }

        // Caso exista a propriedade cleanPageModel, o redirect irá resetar a model da page especificada no nó 'redirect'
        let redirectModel = model;
        if (params.action.redirect.cleanPageModel) {
          redirectModel = {};
          commit('clearPageModel', params.action.redirect);
        }

        // cleanModel irá resetar tudo
        const cleanModel =
        params.action.redirect.cleanModel ?? rootGetters['layout/getConfigEnvironmentDefaults'].cleanModelOnRedirect;
        if (cleanModel) {
          redirectModel = {};
          commit('clear', { state});
          await eventBus.$emit(HANDLERS.ENABLE_FOOTER);
        }

        redirect(state, params, redirectModel, defaultFilter);
        return;
      }

      if ('procedure' in params.action) {
        requestParams = JSON.parse(JSON.stringify(params.action.procedure));
        actionType = 'procedure';
      }

      if ('component' in params.action) {
        requestParams = JSON.parse(JSON.stringify(params.action.component));
        actionType = 'component';
      }

      if ('requestApi' in params.action) {
        requestParams = JSON.parse(JSON.stringify(params.action.requestApi));
        actionType = 'requestApi';
      }

      if ('mockResponse' in params.action) {
        mockData = structuredClone(params.action.mockResponse);
        requestParams = {};
        actionType = 'mockResponse';

        if (Array.isArray(mockData['values'])) {
          mockData['values'] = mockData['values'].map(m => {
            if (m && typeof m === 'object') {
              return Object.fromEntries(
                Object.entries(m).map(([key, value]) => {
                  const compiledString = compileDynamicString({
                    page: params.page,
                    mode: getExecuteMode(params),
                    originalString: value,
                    index: params.action?.index || params?.index
                  });
                  return [key, compiledString === value ? null : compiledString];
                })
              );
            }
            return m;
          });
        }
      }

      if (!actionType) {
        showMessage(commit, {
          message: 'Não foi definido uma Procedure ou Componente para esta ação.',
          color: 'error'
        });
        return;
      }

      requestParams.page = params.page;
      requestParams.initialModel = initialModel;
      requestParams.InvokeName = params.action.actionName;
      requestParams.module = rootState.module.modulesAllowed.find(x => x.id === rootState.module.defaultModule).folder;
      requestParams.mode = params.mode;
      requestParams.tab = params.tab;
      requestParams.step = params.step;

      //debugger;
      //if (params.mode !== 'search') requestParams.Entry = state.entries[params.page];

      if (actionType !== 'procedure' && actionType !== 'requestApi' && actionType !== 'mockResponse') {
        requestParams.className = requestParams.className;
        requestParams.methodName = requestParams.methodName;
        requestParams.nameDll = requestParams.nameDll;
        requestParams.namespace = requestParams.namespace;
      }

      if (twoModels) requestParams.auxiliaryModel = state.models[params.page][originalMode];

      requestParams.model = model;
      requestParams.defaultFilter = defaultFilter;

      if (params.action.mode === 'search') {
        commit('setPageFilterOffset', { page: params.page, offsetParams: 0 });

        if (filterTable.offset) {
          filterTable.offset = 0;
        }

        if (filterTable.limit) requestParams.model.limit = filterTable?.limit;
        if (filterTable.offset) requestParams.model.offset = filterTable?.offset;
        if (filterTable.sortBy) requestParams.model.sortBy = filterTable?.sortBy;
        if (filterTable.sortDesc) requestParams.model.sortDesc = filterTable?.sortDesc;
      }

      if (uploadResult) {
        if (params.mode === 'list') {
          for (const idx in requestParams.model) {
            requestParams.model[idx][uploadResult[idx].model] = uploadResult[idx].keyValue;
            requestParams.model[idx][`${uploadResult[idx].model}_id_documento`] = uploadResult[idx].value;
          }
        } else {
          for (let file of uploadResult) {
            requestParams.model[file.model] = file.keyValue;
            requestParams.model[`${file.model}_id_documento`] = file.value;
          }
        }
      }

      let files = {};
      let acceptsFiles = {};

      if (!('ecm' in params.action) && !(actionType === 'mockResponse')) {
        for (let [key, value] of Object.entries(requestParams.model)) {
          if (value instanceof File) {
            files[key] = value;
            requestParams.model[key] = null;
            // let result = getAcceptsFiles(state, params.page, params.mode, params.tab, params.step, key);
            // acceptsFiles = { ...acceptsFiles, ...result }
          }
        }
        // requestParams.acceptsFiles = acceptsFiles;
      }

      if ('runOnce' in params.action.params && params.action.params.runOnce) {
        requestParams.model = null;
        requestParams.initialModel = null;
      }

      let customModelArray = state.schemes[params.page][params.mode].attributes.customModelArray;

      if (actionType === 'mockResponse') {
        var data = mockData;
      } else {
        if (getExecuteMode(params) !== 'list' && !customModelArray) {
          var { data } =
            actionType === 'procedure'
              ? await pageServices.executeProcedureAction(requestParams, files)
              : actionType === 'component'
              ? await pageServices.executeComponentAction(requestParams, files)
              : await pageServices.executeRequestApiAction(requestParams, files);
        } else {
          var { data } =
            actionType === 'procedure'
              ? await pageServices.executeProcedureActionList(requestParams, files)
              : actionType === 'component'
              ? await pageServices.executeComponentActionList(requestParams, files)
              : await pageServices.executeRequestApiAction(requestParams, files);
        }
      }

      if (data?.invalid) {
        showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
        return false;
      }

      // faz redirect somente no portal, no dev não faz!
      if (params.page === 'dev' && page) return;

      const message = getMessageClass(data);

      showMessage(commit, {
        message: data.dictionaryReturns['@ds_retorno'],
        color: data.dictionaryReturns['@message_class'] || message,
        sweetAlert: message !== 'success' ? true : false
      });

      if (actionType === 'component' && params.action.component.download) {
        let { tag, contentType, fileName } = params.action.component.download;

        if (!!fileName === false) {
          var actionName = params.action.actionName ?? params.action.name;
          fileName = `${params.page}-${actionName}`;
        }

        let fileExtension = fileName.split('.').pop();
        if (fileExtension === fileName) {
          fileExtension = 'pdf'; // se o nome do arquivo nao tem extensão assume pdf
        } else {
          fileName = fileName.split('.').shift();
        }

        if (!!contentType === false) {
          contentType = 'application/pdf';
        }

        downloadFile(data.values[0][tag], contentType, fileExtension, fileName);
        // return;
        // removido return para caso haja um after ele ainda seja processado.
      }

      // Propriedade que continua o fluxo de execução mesmo após ds_retorno <> 0
      const { executeAlways } = params?.action?.after ? params.action.after : false;

      // Interrompe o fluxo de execução caso a ação principal retorne erro,
      //    exceto quando executeAlways for especificado no JSON
      if (message !== 'success' && !executeAlways) {
        return false;
      }

      if (params.action.after) {
        if (
          data.dictionaryReturns['@id_retorno'] == 0 ||
          data.dictionaryReturns['@id_retorno'] == null ||
          executeAlways === true
        ) {
          await afterEvents(state, commit, dispatch, params, data, requestParams);
        }
      }
      return true;
    } catch (err) {
      console.error(err);
    }
  },

  resetDefaultFilter: ({ commit }) => {
    commit('resetDefaultFilter');
  }
};
